<template>
    <div class="container">
        <md-dialog :md-active.sync="modConContPorCuent" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }} {{ nroCuenta }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row>
                    <b-row class="d-flex justify-content-center">
                        <!-- <b-row class="d-flex justify-content-center col-12">
                            <h1 class="md-title"><b>{{ labels.subTitle }}</b></h1>
                        </b-row> -->
                        <b-row class="d-flex justify-content-center col-11" v-if="infoCuentas.length > 0">
                            <b-row class="row col-md-12 d-flex justify-content-end">
                                <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="genExcelSaldPorCuent()">
                                    <md-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                                    </md-icon>
                                </md-button>
                            </b-row>
                            <b-table
                                :items="infoCuentas"
                                :fields="fields"
                                hover
                                bordered
                                responsive
                                sticky-header="500px"
                                small
                                class="tblEstandar"
                                head-variant="custom-blue"
                                :per-page="perPage"
                                :current-page="currentPage"
                            >
                                <template #cell(nro_contrato)="data">
                                    <div class="text-right">{{ data.item.nro_contrato }}</div>
                                </template>
                                <template #cell(identificacion)="data">
                                    <div class="text-left">{{ proveedor(data.item.identificacion) }}</div>
                                </template>
                                <template #cell(saldo)="data">
                                    <div class="text-right">{{ formatNumber(data.item.saldo) }}</div>
                                </template>
                            </b-table>
                            <div class="row col-12 mt-1">
                                <div class="col-10 d-flex justify-content-center">
                                    <b-pagination
                                    v-model="currentPage"
                                    :per-page="perPage"
                                    :total-rows="infoCuentas.length"
                                    align="center"
                                    size="md"
                                    class="custom-pagination"
                                    ></b-pagination>
                                </div>
                                <div class="col-2 d-flex justify-content-end">
                                    <label class="mr-2 mb-0">Filas por página:</label>
                                    <b-form-select
                                    v-model="perPage"
                                    :options="[5, 10, 20, 50, 100, 500]"
                                    size="sm"
                                    style="width: 80px;"
                                    ></b-form-select>
                                </div>
                            </div>
                        </b-row>
                        <b-row v-else>
                            <h5>{{ labels.noRow }}</h5>
                        </b-row>
                    </b-row>
                </b-row>
                <md-dialog-actions class="">
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
    import * as XLSX from "exceljs";
    import Tercero from '../../services/Tercero';
export default {
    name : 'ModConsContrPorCuent',
    props : ['modConContPorCuent','infoCuentas','nroCuenta'],
    data : () => ({
        listTercero : [],
        fields : [
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'identificacion', label: 'Proveedor', sortable: false },
            { key: 'tipo_activo', label: 'Tipo activo', sortable: false },
            { key: 'centro_costo', label: 'Centro costo', sortable: false },
            { key: 'saldo', label: 'Saldo', sortable: false },
        ],
        perPage: 500,
        currentPage: 1,
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Cuenta',
                    close : 'Cerrar',
                    subTitle : 'Consulta por cuenta',
                    noRow : 'No hay registros',
                }
            }else{
                return {
                    title : 'Account',
                    close : 'Close',
                    subTitle : 'Inquiry by account',
                    noRow : 'There are no records', 
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
        },
        proveedor(identify){
            if	(identify == null || identify == undefined) {
			return identify
            }
            let nameTercero = this.listTercero.find((tercer) => tercer.identificacion === identify)

            if	(nameTercero == undefined) {
                return "Sin Nombre "+identify
            }
            return nameTercero.nombre
        },
        async genExcelSaldPorCuent(){
            
            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Saldos por cuenta "+this.nroCuenta)

            const titulo = ["Saldos por cuenta "+this.nroCuenta]
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:E1')
            worksheet.getCell('A1').font = { bold : true, size : 12};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            const tituloCelda = [
                'Contrato',
                'Proveedor',
                'tipo activo',
                'Centro de costo',
                'Saldo'
            ]

            worksheet.addRow(tituloCelda)
            for	(let fila = 1;fila<=2;fila++) {
                worksheet.getRow(fila).font = {
                    name: "Arial Black",
                    family: 2,
                    size: 11,
                    bold: true
                }
            }

            this.infoCuentas.map((e) => {
                worksheet.addRow([
                    e.nro_contrato,
                    this.proveedor(e.identificacion),
                    e.tipo_activo,
                    e.centro_costo,
                    this.formatNumber(e.saldo)
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Saldos por cuenta "+this.nroCuenta+".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();
        }
    },
    mounted(){

        Tercero.getAllTercero()
        .then((res) => {
            this.listTercero = res.data.listTercero
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style>

</style>